/**
 * 편집기 도구모음의 **AI 에이전트 도구 버튼** — 튜닝 사례 · 테이블 분석.
 *
 * 원래는 AI 에이전트 패널 머리말에 있었다. 거기 두면 **패널을 열어야만 닿는다** — 이 화면들은
 * 대화와 무관하게 혼자 쓰는 것들이라(사례를 찾아보거나, 테이블 하나를 분석하거나) 대화를
 * 시작할 이유가 없는데도 패널을 열어야 했다. 그래서 「AI 에이전트」 토글 옆으로 옮겼다
 * (사용자 요청 2026-09-11).
 *
 * **아이콘만 두지 않고 레이블을 함께 쓴다**(사용자 요청 2026-09-13) — 아이콘만으로는 무슨 창인지
 * 알 수 없었다. 문구는 메뉴 도구 › 와 같은 키를 쓴다(한 기능이 두 이름으로 보이지 않게).
 *
 * 사용·에러 로그는 여기 없다 — 메뉴 도움말 › 로 옮겼고, 도움말 항목은 툴바 버튼을 두지 않는다
 * (2026-09-13). 창 자체는 여전히 App 이 그린다.
 *
 * **여는 상태와 창 자체는 App 이 쥔다.** 패널 안에 두면 패널이 닫힐 때 모달도 같이 언마운트된다
 * (`AssistantPanel` 은 닫히면 `null` 을 낸다) — 버튼만 밖으로 내고 창을 안에 두면 눌러도
 * 아무 일이 없다.
 *
 * **도구모음은 레이아웃 모드마다 따로 그려진다**(붙임·분리·상하분할 3곳). 버튼을 세 벌로
 * 베끼면 한 곳만 고치는 일이 반드시 생기므로 여기 한 곳에 두고 세 곳이 이것을 쓴다.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiBookOpen, FiDatabase } from 'react-icons/fi';
// 화면에서 끝나는 기능은 서버가 모른다 — 보내는 곳은 이 함수 하나다(services/opsLog.js)
import { logAction } from '../../services/opsLog';

function AssistantToolButtons({ onOpenCaseList, onOpenTableAnalysis, visible = {} }) {
    const { t } = useTranslation();
    // 메뉴 도구 › 의 즐겨찾기를 끈 버튼은 숨긴다 — 기본은 모두 보임(업데이트로 버튼이 사라지면 안 된다)
    const show = { caseList: true, tableAnalysis: true, ...visible };
    // 순서는 메뉴 도구 › 와 같다: 튜닝 사례 · 테이블 분석
    return (
        <>
            {show.caseList && (
                <button
                    type="button" className="detach-inline-btn"
                    onClick={() => { logAction('modal.tuningCases'); onOpenCaseList(); }}
                    title={t('assistant:caseList.title')}
                >
                    <FiBookOpen /> {t('menu:tools.tuningCases')}
                </button>
            )}
            {/* 인덱스 설계(테이블 액세스 분석 탭 포함) — SQL 한 건이 아니라 **테이블**이 단위인 다른 작업이다 */}
            {show.tableAnalysis && (
                <button
                    type="button" className="detach-inline-btn"
                    onClick={() => { logAction('modal.indexDesign'); onOpenTableAnalysis('index'); }}
                    title={t('menu:tools.indexDesign')}
                >
                    <FiDatabase /> {t('menu:tools.indexDesign')}
                </button>
            )}
        </>
    );
}

AssistantToolButtons.propTypes = {
    onOpenCaseList: PropTypes.func.isRequired,
    onOpenTableAnalysis: PropTypes.func.isRequired,
    visible: PropTypes.shape({ caseList: PropTypes.bool, tableAnalysis: PropTypes.bool }),
};

export default AssistantToolButtons;
